export const setItem = <T>(key: string, value: T): void => {
    if (typeof key !== "string" && typeof key !== "number") {
        throw new Error("Invalid Key!");
    }
    localStorage.setItem(key.toString(), JSON.stringify(value));
};

export const getItem = <T>(key: string, defaultValue: T): T => {
    if (typeof key !== "string" && typeof key !== "number") {
        throw new Error("Invalid Key!");
    }
    const data = localStorage.getItem(key.toString());
    return (data && JSON.parse(data)) || defaultValue;
};

export const removeItem = (key: string): void => {
    if (typeof key !== "string" && typeof key !== "number") {
        throw new Error("Invalid Key!");
    }
    localStorage.removeItem(key.toString());
};
